import { nanoid } from 'nanoid';
const TAB_SESSION_KEY = 'TAB_SESSION_ID';
const BROWSER_SESSION_KEY = 'BROWSER_SESSION_ID';
export const getTabId = (() => {
    var _a;
    const tabWindow = window;
    let tabId = (_a = tabWindow[TAB_SESSION_KEY]) !== null && _a !== void 0 ? _a : sessionStorage.getItem(TAB_SESSION_KEY);
    // Keep sessionStorage empty during normal tab lifetime so duplicated tabs
    // do not inherit the active tab id.
    sessionStorage.removeItem(TAB_SESSION_KEY);
    if (!tabId) {
        tabId = `${Date.now()}-${nanoid()}`;
    }
    tabWindow[TAB_SESSION_KEY] = tabId;
    const persistTabId = () => {
        sessionStorage.setItem(TAB_SESSION_KEY, tabWindow[TAB_SESSION_KEY]);
    };
    window.addEventListener('pagehide', persistTabId);
    window.addEventListener('beforeunload', persistTabId);
    return () => tabWindow[TAB_SESSION_KEY];
})();
/** Browser session id from `GET /api/get-session`, shared with backend telemetry for joins. */
export const setBrowserSessionId = (sessionId) => {
    const sessionWindow = window;
    if (sessionId) {
        sessionWindow[BROWSER_SESSION_KEY] = sessionId;
    }
    else {
        delete sessionWindow[BROWSER_SESSION_KEY];
    }
};
/** Prefix marks a client-minted id so it is never mistaken for one the backend can join on. */
const LOCAL_SESSION_PREFIX = 'local-';
/**
 * The server id when there is one, otherwise a per-tab id minted on first read. Without the
 * fallback a `get-session` response that omits `session-id` would leave every event with no
 * sessionId at all, so nothing could be grouped into a session. `getAppMetadata` resolves before
 * metrics are configured, so a real id is always in place before the first event.
 */
export const getBrowserSessionId = () => {
    const sessionWindow = window;
    if (!sessionWindow[BROWSER_SESSION_KEY]) {
        sessionWindow[BROWSER_SESSION_KEY] = `${LOCAL_SESSION_PREFIX}${nanoid()}`;
    }
    return sessionWindow[BROWSER_SESSION_KEY];
};
/** Editor WebSocket session id — set on initialize, stamped onto every event of that load. */
let socketSessionId;
export const setSocketSessionId = (id) => {
    socketSessionId = id || undefined;
};
/** Clear only when the session is still owned by the caller. */
export const clearSocketSessionId = (expectedId) => {
    if (socketSessionId === expectedId)
        socketSessionId = undefined;
};
export const getSocketSessionId = () => socketSessionId;
